export function DataTable({ columns, rows, testid, onRowClick, empty = "No records" }) {
  return (
    <div className="border border-border bg-card overflow-auto max-h-[70vh]" data-testid={testid}>
      <table className="w-full text-sm border-collapse">
        <thead className="sticky top-0 z-10 bg-secondary">
          <tr>
            {columns.map((c) => (
              <th key={c.key} className="text-left text-[11px] uppercase tracking-[0.1em] font-bold px-3 py-2 border-b border-border whitespace-nowrap">
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={columns.length} className="px-3 py-10 text-muted-foreground text-sm font-mono text-xs" data-testid={`${testid}-empty`}>
                {empty}
              </td>
            </tr>
          )}
          {rows.map((r, i) => (
            <tr
              key={r.id || i}
              onClick={onRowClick ? () => onRowClick(r) : undefined}
              className={`${i % 2 ? "bg-foreground/[0.02]" : ""} ${onRowClick ? "cursor-pointer hover:bg-[hsl(var(--warning))]/10" : ""} transition-colors duration-150`}
            >
              {columns.map((c) => (
                <td key={c.key} className="px-3 py-2 border-b border-border align-top">
                  {c.render ? c.render(r) : r[c.key] ?? "—"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
